import { TypedRootState } from '../types';

export const selectForceAnalysisChange = (state: TypedRootState) => state.forceAnalysisChange;
